import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { RootState } from '../../../store/modules';
import { useEffect, useState } from 'react';
import {
  itemBomListGetApi,
  ItemBomResponseType,
  ProductionResponseType,
} from '../../../api/apiConfig';
import useFetch from '../../../api/useFetch';
import { ProductionCircularCardFix } from '../../common/card/ProductionCircularCardFix';
export const ProductionProgressTabletWorker = () => {
  const param = useParams();

  const navigate = useNavigate();

  const socketData = useSelector((state: RootState) => state.socketData);

  const [productionData, setProductionData] =
    useState<ProductionResponseType | null>(null);

  const [bom, setBom] = useState<ItemBomResponseType | null>(null);

  const productionDatas = useSelector(
    (state: RootState) => state.socketData.production
  );

  const { fetch: fetchItemBomListGet } = useFetch({
    fetchFunction: itemBomListGetApi,
    onSuccess: (data: ItemBomResponseType) => setBom(data),
  });

  useEffect(() => {
    if (!bom) return;

    const productionTarget =
      productionDatas.find(
        (production) => Number(production.id) === Number(param.productionId)
      ) || null;

    if (
      productionTarget?.progress === 'C' ||
      productionTarget?.progress === 'E'
    ) {
      window.alert('생산일정이 마감되었습니다. 이전페이지로 돌아갑니다.');
      navigate('/production-progress-tablet');
    }

    setProductionData(productionTarget);
  }, [socketData, bom]);

  useEffect(() => {
    if (!param.productionId) return;
    if (!param.itemId) return;
    fetchItemBomListGet(Number(param.itemId));
  }, [param]);

  return (
    <Container id='container'>
      <ProductionCircularCardFix
        width={550}
        height={570}
        hover={true}
        onClick={undefined}
        itemName={productionData ? productionData.item.PROD_DES : ''}
        itemSize={productionData ? productionData.item.SIZE_DES : ''}
        workbayName={productionData ? productionData.workbayName : ''}
        current={productionData ? productionData.productionCnt : 0}
        goal={productionData ? productionData.productionGoal : 0}
        progress={productionData ? productionData.progress : ''}
      />
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
